import { useContext, useLayoutEffect } from "react"
import { GlobalContext } from "../context/globalContextProvider"

export default () => {
  const context = useContext(GlobalContext)
  let sidebarNavContainer = null
  let sidebarNavColumn = null

  const querySidebarElementsMaybe = () => {
    if (!sidebarNavContainer) {
      sidebarNavContainer = document.querySelector(
        '[data-testid="dev-docs-layout-navigation"]'
      )
    }
    if (!sidebarNavColumn) {
      sidebarNavColumn = document.querySelector(
        '[data-testid="dev-docs-sidebar-sidebar-column"]'
      )
    }
  }

  /**
   * Save the sidebar height and scroll position.
   */
  const save = () => {
    querySidebarElementsMaybe()
    context.lastSidebarColHeight = sidebarNavColumn?.scrollHeight
    context.lastSidebarScrollTop = sidebarNavContainer.scrollTop
  }

  /**
   * If the previous and current pages have the same sidebar, restore the sidebar scroll position
   */
  const restore = () => {
    querySidebarElementsMaybe()
    if (sidebarNavColumn?.scrollHeight === context.lastSidebarColHeight) {
      sidebarNavContainer.scrollTop = context.lastSidebarScrollTop
    }
  }

  useLayoutEffect(() => {
    restore()
    window.addEventListener("resize", save)

    return () => {
      save()
      window.removeEventListener("resize", save)
    }
  }, [])
}
